import { Component, Input, OnInit } from '@angular/core'
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { MILITARY_OPTIONS } from '@se-po/shared-data-access-models'
import { BaseValueAccessorDirective } from '@se-po/shared-ui-form-directives'
import { SeFeSelectOption } from 'se-fe-form-field-select'
import { SeFeTranslationsLoader } from 'se-fe-translations'

@Component({
  selector: 'se-po-military-select',
  templateUrl: './military-select.component.html',
  styleUrls: ['./military-select.component.scss'],
  hostDirectives: [BaseValueAccessorDirective],
  standalone: false,
})
export class MilitarySelectComponent implements OnInit {
  @Input() public seFeDataLabel?: string

  public militaryStatusOptions: SeFeSelectOption[] = []
  public loaded: boolean
  public ngControl = BaseValueAccessorDirective.ngControl(this) // get the forwarded control

  constructor(private seFeTranslationsLoader: SeFeTranslationsLoader,
              private translateService: TranslateService
  ) { }

  public get form(): UntypedFormGroup | UntypedFormArray {
    return this.ngControl?.control?.parent
  }

  public ngOnInit(): void {
    this.loaded = false
    this.initTranslations()
  }

  public initTranslations(): void {
    this.seFeTranslationsLoader.load('shared/ui-military-select/assets/translations').then(() => {
      MILITARY_OPTIONS.forEach(val => {
        this.militaryStatusOptions.push({
          label: this.translateService.instant(`SE_PO_UI_MILITARY_SELECT.STATUS.${val}`),
          value: val
        })
      })
      this.loaded = true
    })
  }
}
